import { Chip, SxProps } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface IChipWithDataProps {
  username: string;
  avatar?: string;
  sx?: SxProps;
}

const ChipWithData: React.FC<IChipWithDataProps> = ({
  username,
  avatar,
  sx,
}) => {
  const userImg = require('assets/Profile/buku_default_avatar.png');
  const navigate = useNavigate();
  return (
    <Chip
      clickable
      component="button"
      onClick={() => navigate(`/profile/${username}/feed`)}
      sx={{
        ...sx,
        color: 'white',
        fontWeight: '600',
        px: '5px',
        py: '20px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '25px',
        cursor: 'pointer',
      }}
      avatar={<Avatar alt={username} src={avatar || userImg} />}
      label={`@${username}`}
    />
  );
};

export default ChipWithData;
